module.exports = __webpack_public_path__ + "static/img/red_circle_sm.d9b84a8d.png";